import type { GridProps} from '@chakra-ui/react'
import { Grid, Image, Spinner, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'
import { useGetBrandLogo } from '../../hooks/useDocuments'
import car from '../../images/apps/car.svg'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { formatVehicleBrand, formatVehicleModel } from 'BrokerTsLib/src/dtos'

export interface WizzardHeaderVehicleInfoProps extends GridProps {

}

export const WizzardHeaderVehicleInfo = (props: WizzardHeaderVehicleInfoProps) => {
  const { isScrolled } = useWizzardHeader()
  const [logoSize, setLogoSize] = useState(96)

  const { insuranceParams: ip } = useInsuranceParams()
  const insuranceParams = ip as InsuranceParamsDto

  const brand = formatVehicleBrand(insuranceParams?.vehicle)
  const model = formatVehicleModel(insuranceParams?.vehicle)
  const druh = insuranceParams?.vehicle.druh

  const { data, isLoading, isError } = useGetBrandLogo(druh, brand, { retry: false })

  useEffect(() => {
    setLogoSize(isScrolled ? 30 : 96)
  }, [isScrolled])

  return (
    <Grid
      sx={{
        position: 'relative',
        w: { base: '100%', md: '250px' },
        gridTemplateColumns: {
          base: 'auto 1fr',
          md: '1fr',
        },
        mt: { md: isScrolled ? -6 : -8 },
        mb: { md: -4 },
        borderRadius: { base: 'md', md: 0 },
        overflow: {
          base: 'hidden',
          md: 'visible',
        },
        transition: 'all 200ms ease-in-out',
      }}
    >
      <Grid
        sx={{
          p: { base: 2, md: isScrolled ? 3 : 6 },
          justifyContent: 'center',
          bg: 'white',
          borderTopRadius: { md: 'md' },
          transition: 'all 200ms ease-in-out',
        }}
      >

        {isLoading && <Spinner />}
        {!isLoading && isError && <Image src={car} />}
        {!isLoading && !isError && data?.data && <Image
          src={'data:image/png;base64,' + data.data}
          alt={brand ?? undefined}
          sx={{
            width: {
              base: 12,
              md: `${logoSize}px`,
            },
            height: {
              base: 12,
              md: `${logoSize}px`,
            },
            transition: 'all 200ms ease-in-out',
          }}
        />}
      </Grid>

      <Grid
        sx={{
          px: 4,
          pt: { base: 0, md: 2 },
          pb: { base: 0, md: isScrolled ? 2 : 4 },
          alignContent: 'center',
          alignItems: 'center',
          bg: 'neutral.50',
        }}
      >
        {brand && (
          <Text sx={{ fontSize: isScrolled ? 'xs' : 'md' }}>{brand}</Text>
        )}
        {model && (
          <Text sx={{ fontSize: isScrolled ? 'xs' : 'md', fontWeight: 600 }}>
            {model}
          </Text>
        )}
      </Grid>
    </Grid>
  )
}
